export default __webpack_public_path__ + "static/media/node.5a0b807f.jpeg";